import React, { forwardRef, useEffect, useState } from "react";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import { s3FileManagerServices } from "../../../APIServices/SitePilotManagement/s3FileManagerServices";
import { useParams } from "react-router";
import Swal from "sweetalert2";

const ExtractedZipFile = forwardRef(({ Show, Hide, Title, sourceKey, getTotalS3Folders }, ref) => {
  const [buttonLoader, setButtonLoader] = useState(false);
  const [selectedPaths, setSelectedPaths] = useState([]);
  const [destinationKey, setDestinationKey] = useState("");
  const [loader, setLoader] = useState(false);
  const [fileManager, setFileManager] = useState([]);

  const getS3Folders = async () => {
    setLoader(true);
    let data = await s3FileManagerServices.getS3Folders("root", "", "", "folder");
    setFileManager(data?.data || []);
    setLoader(false);
  };

  const extractS3ZipController = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Extract!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Extract it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true)
        let userData = {  };
        userData.sourceKey = sourceKey?.[0]
        userData.destinationKey = `${destinationKey}`
        let data = await s3FileManagerServices.extractS3ZipController(
          userData
        );
        setButtonLoader(false)
        if (data?.statusCode === 200) {
          setDestinationKey("")
          getTotalS3Folders()
          Hide()
        }
      }
    });
  };

  const getChildren = (path, items = fileManager) => {
    if (!path) return items;
    for (const item of items) {
      if (item.fullPath === path) return item.children || [];
      if (item.children?.length) {
        const found = getChildren(path, item.children);
        if (found.length) return found;
      }
    }
    return [];
  };

  const getFolderName = (path, items = fileManager) => {
    for (const item of items) {
      if (item.fullPath === path) return item.name;
      if (item.children?.length) {
        const found = getFolderName(path, item.children);
        if (found) return found;
      }
    }
    return null;
  };

  const handleChange = (level, value) => {
    const newSelectedPaths = [...selectedPaths];
    newSelectedPaths[level] = value;
    newSelectedPaths.splice(level + 1);
    setSelectedPaths(newSelectedPaths);
    setDestinationKey(value || newSelectedPaths[level - 1] || "");
  };

  const renderDropdowns = () => {
    const dropdowns = [];
    let currentItems = fileManager;
    for (let i = 0; i <= selectedPaths.length; i++) {
      if (!currentItems || currentItems.length === 0) break;
      const parentPath = i === 0 ? null : selectedPaths[i - 1];
      const parentName = parentPath ? getFolderName(parentPath) : null;
      dropdowns.push(
        <Form.Group className="mb-1" key={i}>
          <Form.Label className="mb-1 fw-bold">
            {parentName
              ? `Select Folder inside "${parentName}"`
              : "Select Root Folder"}
            {i === 0 &&
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            }
          </Form.Label>
          <Form.Select
            disabled={loader}
            value={selectedPaths[i] || ""}
            onChange={(e) => handleChange(i, e.target.value)}
          >
            <option value="">Select Folder Path</option>
            {i === 0 &&
              <option value="/">Main Root</option>
            }
            {currentItems.map((folder) => (
              <option key={folder.fullPath} value={folder.fullPath}>
                {folder.name}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      );
      const currentPath = selectedPaths[i];
      if (!currentPath) break;
      currentItems = getChildren(currentPath);
    }
    return dropdowns;
  };

  useEffect(() => {
    getS3Folders()
  }, []);
  return (
    <>
      <Modal show={Show} onHide={Hide} placement="end">
        <div ref={ref} className="d-flex flex-column h-100">
          <Modal.Header closeButton>
            <Modal.Title style={{fontSize: 15}}>{Title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {renderDropdowns()}
          </Modal.Body>
          <div className="text-end p-2 border-top">
            <Button
              onClick={extractS3ZipController}
              disabled={buttonLoader || !destinationKey}
              title={Title}
              size="sm"
              variant="outline-primary"
            >
              {buttonLoader ? (
                <div className="hstack gap-2">
                  <Spinner size="sm" /> Extracting...
                </div>
              ) : (
                "Extract Now"
              )}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
});

export default ExtractedZipFile;
